import { render, staticRenderFns } from "./delete-vendor-modal.vue?vue&type=template&id=2f55c98a&lang=pug"
import script from "./delete-vendor-modal.vue?vue&type=script&lang=js"
export * from "./delete-vendor-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports